export default "__VITE_ASSET__BQ$h3Aq___"